import enUS from './en-US'
import deDE from './de-DE'

export default {
  'en-US': enUS,
  'de-DE': deDE
}
